import React, { useEffect, useState, useContext, forwardRef, useImperativeHandle } from "react";
import { getStuff, postStuff } from '../helpers/auth'
import { AlertsContext } from './Layout'
import { authenticatedContext } from '../App'
import { ButtonWIcon, TextInput, CloseButton } from './Inputs'
import { equalsCheck } from "../helpers/misc";


export const Tags = forwardRef(({ client_id, tagsSaveRef = null, create_user_page = false }) => {
    // Your code here

    const addAlertBanner = useContext(AlertsContext);
    const { authenticated, setAuthenticated } = useContext(authenticatedContext);

    const [editActive, setEditActive] = useState(create_user_page);
    const [data, setData] = useState(null);
    const [initData, setInitData] = useState(null);
    const [showSave, setShowSave] = useState(false);
    const [newTagIn, setNewTagIn] = useState("");

    useImperativeHandle(tagsSaveRef, () => ({
        handleSave
    }));


    function updateTagsFromDb() {
        getStuff(`client/${client_id}/tags/`).then((res) => {
            if (res.status === 200) {
                setInitData(JSON.parse(JSON.stringify(res.data)));
                setData(JSON.parse(JSON.stringify(res.data)));
            } else if (res.status === 401) {
                setAuthenticated(false);
            } else {
                addAlertBanner("Něco se pokazilo", "danger");
            }
        });
    }

    useEffect(() => {
        updateTagsFromDb();
    }, [])

    useEffect(() => {
        if (data === null || initData === null) return;
        if (equalsCheck(data.tags, initData.tags)) {
            setShowSave(false);
        } else {
            setShowSave(true);
        }
    }, [data]);


    function handleEdit() {
        setEditActive(!editActive);
    }
    function handeleCheckboxChange(tag) {
        // Create a new copy of data and modify that
        let newData = { ...data };
        // Check if the tag is already in the array
        const tagIndex = newData.tags.findIndex(t => t.tag_id === tag.tag_id);
        if (tagIndex !== -1) {
            // If the tag is already in the array, remove it
            newData.tags.splice(tagIndex, 1);
        } else {
            // If the tag is not in the array, add it
            newData.tags.push(tag);
        }
        // Set the state with the new copy of data
        setData(newData);
    }

    function handleSave() {
        if (!showSave) {
            return;
        }
        const dataTagIds = data.tags.map(tag => tag.tag_id);
        const initDataTagIds = initData.tags.map(tag => tag.tag_id);

        let newTagIds = dataTagIds.filter(tag_id => !initDataTagIds.includes(tag_id));
        newTagIds = [...newTagIds, ...initDataTagIds.filter(tag_id => !dataTagIds.includes(tag_id))]
        const body = { tag_ids: newTagIds, client_id: client_id }
        console.log("BODY", body)
        postStuff('client/tags_update/', body).then((res) => {
            if (res.status === 200) {
                addAlertBanner("Štítky byly úspěšně uloženy", "success");
                updateTagsFromDb();
            } else if (res.status === 401) {
                setAuthenticated(false);

            } else if (res.status == 403) {
                addAlertBanner("Nemáte dostatečné oprávnění", "warning")
            } else {
                addAlertBanner("Něco se pokazilo", "danger");
            }
        });
    }

    function isChecked(tag) {
        return data.tags.find(t => t.tag_id === tag.tag_id) !== undefined;
    }

    function handleNewTag() {
        if (newTagIn === "") {
            addAlertBanner("Štítek nemůže být prázdný", "danger");
            return;
        };

        if (newTagIn.length > 20) {
            addAlertBanner("Štítek může mít maximálně 20 znaků", "danger");
            return;
        }


        const body = { name: newTagIn }
        postStuff('create_tag/', body).then((res) => {
                if (res.status === 200) {
                    addAlertBanner("Štítek byl úspěšně přidán", "success");
                    updateTagsFromDb();
                    setNewTagIn("");
                } else if (res.status === 401) {
                    setAuthenticated(false);
                } else if (res.status == 403) {
                    addAlertBanner("Nemáte dostatečné oprávnění", "warning")
                } else {
                    addAlertBanner("Něco se pokazilo", "danger");
                }
        });
    }

    if (data == null) return <p>Načítám data..</p>;
    if (!editActive) {
        return (
            <div className="profile-tags">
                <div className="tags-header">
                    <div className="tags-title">ŠTÍTKY</div>
                    <div className="tags-edit-container">
                        <ButtonWIcon iconSrc={"/img/svg/edit.svg"} onClick={handleEdit} />
                    </div>
                </div>
                <div className="tags-list">
                    {
                        data.tags.map((tag, index) => {
                            return (
                                <div className="tag" style={{ backgroundColor: tag.color }} key={index}>
                                    {tag.name}
                                </div>
                            );
                        })
                    }
                </div>
            </div>
        );
    }
    else {

        return (
            <div className="profile-tags">
                <div className="tags-header">
                    <div className="tags-title">ŠTÍTKY - EDITACE</div>
                    <div className="tags-edit-container">
                        {!create_user_page && <CloseButton onClick={handleEdit} />}
                    </div>
                </div>
                <div className="tags-list">
                    {
                        data.availible_tags.map((tag, index) => {
                            return (
                                <div className="tag-row" key={index}>
                                    <div className="tag" style={{ backgroundColor: tag.color }} >
                                        {tag.name}
                                    </div>
                                    <input type="checkbox" checked={isChecked(tag)} onChange={() => { handeleCheckboxChange(tag) }} />
                                </div>
                            );
                        })
                    }
                </div>

                <div className="new-tag-container">
                    <TextInput value={newTagIn} setValue={setNewTagIn} placeholder={"Nový štítek"} />
                    <ButtonWIcon iconSrc={"/img/svg/add_white.svg"} onClick={handleNewTag} text={"přidat"} style={{ backgroundColor: "#795BF3", color: "white" }} />
                </div>
                {
                    showSave && !create_user_page && <ButtonWIcon
                        iconSrc={"/img/svg/save.svg"}
                        onClick={handleSave}
                        style={{ backgroundColor: "#68E965" }}
                        text={"Uložit"} />
                }
            </div>
        )
    }
});

export default Tags;